import {
  createTheme,
  responsiveFontSizes,
} from "@mui/material/styles";

import {
  atlanticColor,
  orangePeelColor,
} from "assets/jss/material-dashboard-pro-react";

const theme = responsiveFontSizes(
  createTheme({
    palette: {
      primary: { main: orangePeelColor[0] },
      secondary: { main: atlanticColor[0] },
    },

    typography: {
      fontFamily: ['"Be Vietnam"'],
      h6: { textTransform: "none" },
      subtitle1: { textTransform: "none" },
      subtitle2: { textTransform: "none" },
    },

    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: "14px",
          },
        },
      },

      MuiInputBase: {
        styleOverrides: {
          root: {
            color: "inherit",
            "& fieldset": {
              borderColor: "transparent",
            },
          },
        },
      },

      MuiSelect: {
        styleOverrides: {
          select: {
            "&:focus": {
              backgroundColor: "transparent",
            },
          },
        },
      },
    },
  })
);

export { theme };
